var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_-_import",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:currentColor}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1683",
    fill: "none",
    d: "M0 0H20V20H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2965",
    transform: "translate(-23.523 -25.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3058",
    d: "M40.28 37.471a.5.5 0 0 0-.5.5v4.148H27.223v-4.148a.5.5 0 0 0-1 0v4.648a.5.5 0 0 0 .5.5H40.28a.5.5 0 0 0 .5-.5v-4.648a.5.5 0 0 0-.5-.5z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3059",
    d: "M33.008 39.7a.5.5 0 0 0 .545.108.5.5 0 0 0 .163-.108l3.773-3.773a.5.5 0 0 0-.707-.707l-2.92 2.92V27.9a.5.5 0 0 0-1 0v10.24l-2.92-2.92a.5.5 0 0 0-.707.707z",
    className: "cls-2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export_icon.1f4a8817d8e4e988a9224a430b858d46.svg";
export { ForwardRef as ReactComponent };